export const classes = {
  cell: 'py-6',
};
